import React, { ReactNode } from 'react';

import ItemStackBlock from 'blocks/ItemStackBlock';
import SharingComponent from 'components/SharingComponent';
import SearchListInput from 'elements/SearchListInput';
import UppercaseHeading from 'elements/UppercaseHeading';
import { FormattedMessage } from 'react-intl';
import useForm, { FormType } from 'utils/hooks/useForm';

import { PreorderProfileListItem } from 'api/textile_deals/fetchPreorders';
import TextilePreorderProfileListItem from './TextilePreorderProfileListItem';

interface PublicTextilePreorderProfileListProps {
  onProfileClick?: (virtual: boolean, preorderId?: number, profileId?: number) => void;
  textileOrderId?: number;
  inviteLink?: string;
  profiles: PreorderProfileListItem[];
}

interface FormProps {
  form: FormType;
}

const TextilePreorderProfileList: React.FC<
  PublicTextilePreorderProfileListProps & FormProps
> = (props) => {
  const filteredProfiles = (): PreorderProfileListItem[] => {
    const { form, profiles } = props;

    const filteredProfiles: PreorderProfileListItem[] = [];
    const nameLowercase = form.values.filter
      ? form.values.filter.trim().toLowerCase()
      : '';

    profiles.forEach((itm) => {
      if (itm.name && itm.name.toLowerCase().indexOf(nameLowercase) > -1) {
        filteredProfiles.push(itm);
      }
    });

    return filteredProfiles;
  };

  const renderList = () => {
    const { form, onProfileClick, inviteLink } = props;

    let heading: ReactNode;

    const profiles = filteredProfiles();

    heading = (
      <FormattedMessage
        id="students filter count"
        values={{
          count: profiles.length
        }}
      />
    );

    return (
      <ItemStackBlock gap="L">
        <SearchListInput form={form} placeholderId="Find student" />

        <ItemStackBlock gap="M">
          <UppercaseHeading>{heading}</UppercaseHeading>

          {profiles.length !== 0 &&
            profiles.map((profile) => (
              <TextilePreorderProfileListItem
                key={profile.preorder_id}
                profile={profile}
                preorder_deactivated={profile.preorder_deactivated}
                onClick={onProfileClick}
              />
            ))}
        </ItemStackBlock>

        {profiles.length === 0 && (
          <SharingComponent
            label="invite header"
            buttonOutside={true}
            modalHeader="invite link"
            message="Nuggit invite text"
            buttonColor="WHATSAPP"
            url={inviteLink}
          />
        )}
      </ItemStackBlock>
    );
  };

  return renderList();
};

export default (props: PublicTextilePreorderProfileListProps) => {
  const form = useForm();
  // @ts-ignore
  return <TextilePreorderProfileList {...props} form={form} />;
};
